// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';

export default styled.div`
  .pickup-banner-container {
    background: ${(props) => props.theme.colorPalette.gray[300]};
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM}
      ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    display: flex;
    border-radius: 6px;
    margin: 7px 0 32px 0;
  }
  .pickup-banner-container-redesigned {
    ${(props) =>
      props.isAddedToBagRedesign
        ? `
          background: ${props.theme.colorPalette.white};
          flex-direction: column;
          border-radius: 6px;
          padding: 0px;
          border: 1px solid #00a4e4;
        `
        : ''}
  }
  .pickup-banner-heading {
    ${(props) =>
      props.isAddedToBagRedesign
        ? `
          background-color: ${props.theme.colorPalette.blue[100]};
          color: ${props.theme.colorPalette.blue[200]};
          border-radius: 6px;
          padding: 8px 0 8px 15px;
          border-bottom-left-radius: 0;
          border-bottom-right-radius: 0;
        `
        : ''}
  }
  .pickup-banner-store-text {
    padding-bottom: 5px;
    margin-top: 16px;
  }
  .content-wrap {
    flex: 1;
    ${(props) =>
      props.isAddedToBagRedesign
        ? `
        display: flex;
        padding: 0 12px 16px 18px;
        `
        : ''}
  }

  .content-wrap-error {
    flex: 1;
  }

  .pickup-cta {
    background: ${(props) => props.theme.colorPalette.blue.C900};
    height: 42px;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    min-width: 103px;
    margin-left: 6px;
    align-self: flex-end;
    border-radius: 6px;
  }
  .error-icon {
    width: 24px;
    height: 24px;
  }
  .error-message-para {
    display: flex;
  }
  .store-name {
    text-transform: capitalize;
  }
`;
